import {
    AdditionalRoundPassive,
    AgreementsPanel,
    ContractorVerification,
    DemandAdditionalInfo,
    DocumentsPanel,
    EvaluationFinish,
    OfferChoice,
    OfferChoiceApproval,
    OffersChoiceResult,
    OffersEvaluation,
    OffersPanel,
    PapersGenerator,
    PrimaryTenderChoice,
    StageFinish
} from "./panels";
import ContractorVerificationService from "services/ContractorVerificationService";
import OfferEvaluationService from "services/OfferEvaluationService";
import OfferChoiceService from "services/OfferChoiceService";
import OfferChoiceApprovalService from "services/OfferChoiceApprovalService";
import OffersChoiceResultService from "services/OffersChoiceResultService";
import AgreementsService from "services/AgreementsService";
import SiwzService from "services/SiwzService";
import AdditionalRoundPassiveService from "services/AdditionalRoundPassiveService";
import DemandOffersService from "services/DemandOffersService";
import DemandAdditionalInfoService from "services/DemandAdditionalInfoService";
import {DemandValidation} from "constants/DemandValidation";

export default {
    mp_3_offers: OffersPanel,
    mp_3_documents: DocumentsPanel,
    mp_3_contractor_verification: ContractorVerification,
    mp_3_offers_evaluation: OffersEvaluation,
    mp_3_offer_choice: OfferChoice,
    mp_3_offer_choice_approval: OfferChoiceApproval,
    mp_3_additional_round_passive: AdditionalRoundPassive,
    mp_3_primary_tender_choice: PrimaryTenderChoice,
    mp_3_offers_choice_result: OffersChoiceResult,
    mp_3_evaluation_finish: EvaluationFinish,
    mp_3_stage_finish: StageFinish,
    mp_3_papers_generator: PapersGenerator,
    mp_3_agreements: AgreementsPanel,
    mp_3_evaluation_additional_info: DemandAdditionalInfo,
}

export const panelsValidationKeys = {
    mp_3_offers: (id) => DemandOffersService.validate(id),
    mp_3_documents: (id) => SiwzService.validateDocuments(id),
    mp_3_contractor_verification: (id) => ContractorVerificationService.validate(id),
    mp_3_offers_evaluation: (id) => OfferEvaluationService.validate(id),
    mp_3_offer_choice: (id) => OfferChoiceService.validate(id),
    mp_3_offer_choice_approval: (id) => OfferChoiceApprovalService.validate(id),
    mp_3_additional_round_passive: (id) => AdditionalRoundPassiveService.validate(id),
    mp_3_primary_tender_choice: (id) => null,
    mp_3_offers_choice_result: (id) => OffersChoiceResultService.validate(id),
    mp_3_evaluation_finish: (id) => null,
    mp_3_stage_finish: (id) => null,
    mp_3_papers_generator: (id) => null,
    mp_3_agreements: (id) => AgreementsService.validate(id),
    mp_3_evaluation_additional_info: (id) => DemandAdditionalInfoService.validate(id, DemandValidation.EVALUATION_ADDITIONAL_INFO),
}